import { useEffect, useState } from "react";
import api from "../lib/api";

let cache = null;

export function useSiteTexts() {
  const [texts, setTexts] = useState(cache || {});

  useEffect(() => {
    if (cache) return;
    api
      .get("/texts")
      .then((r) => {
        cache = r.data;
        setTexts(r.data);
      })
      .catch(() => {});
  }, []);

  return (key, fallback) => texts[key] ?? fallback;
}

export function applyTitleFont(font) {
  if (!font) return;
  const id = "dynamic-title-font";
  let link = document.getElementById(id);
  if (!link) {
    link = document.createElement("link");
    link.id = id;
    link.rel = "stylesheet";
    document.head.appendChild(link);
  }
  link.href = `https://fonts.googleapis.com/css2?family=${font.replace(/ /g, "+")}:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500&display=swap`;
  document.documentElement.style.setProperty("--font-titles", `"${font}"`);
}

export function applyAccentColor(color) {
  if (!color) return;
  document.documentElement.style.setProperty("--accent-gold", color);
}
